import { SpecSection } from 'Components/SpecSection';
import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import type { VehicleMainInfo, VehicleSpecification } from 'Pages/vehicles/helpers/vehicle.schema';

import { SPECIFICATION_FIELDS } from './SpecificationSection.const';

export type SpecificationSectionData = VehicleSpecification & Pick<VehicleMainInfo, 'make' | 'model'>;
export const SpecificationSection: React.FC = () => {
	const { mainInfo, specification } = useVehicleData();

	const { make, model } = mainInfo;

	const specSectionData: SpecificationSectionData = {
		...specification,
		make,
		model,
	};

	return <SpecSection data={specSectionData} fields={SPECIFICATION_FIELDS} />;
};
